// Auto-extracted from Landing.jsx — shared landing atoms.
import React from 'react';

const tt = (node, lang) => (node && (node[lang] || node.en)) || '';

// ─────────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────────
const Section = ({ id, children, className = '' }) => (
  <section id={id} className={`relative z-10 px-6 md:px-10 ${className}`}>
    <div className="max-w-[1240px] mx-auto">{children}</div>
  </section>
);

const Eyebrow = ({ children }) => <div className="reva-eyebrow">{children}</div>;

// ── Cinematic background field (used in hero) ───────────────────────────────
function HeroOrbField() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full opacity-50 reva-orbit-slow" style={{ border: '1px dashed rgba(0,168,107,0.16)' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[760px] rounded-full opacity-60 reva-orbit-mid"  style={{ border: '1px dashed rgba(0,168,107,0.30)' }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full" style={{ background: 'radial-gradient(closest-side, rgba(0,168,107,0.22), transparent 70%)' }} />
      <div className="reva-drift-line" style={{ top: '22%' }} />
      <div className="reva-drift-line" style={{ top: '64%', animationDelay: '2.4s' }} />
      <div className="reva-drift-line" style={{ top: '82%', animationDelay: '4.1s' }} />
      {Array.from({ length: 18 }).map((_, i) => {
        const left = (i * 7.5 + 6) % 100;
        const top  = (i * 13.7 + 8) % 100;
        const delay = (i % 5) * 0.6;
        const isSignal = i % 3 === 0;
        return (
          <span key={i} className="absolute rounded-full reva-pulse" style={{
            left: `${left}%`, top: `${top}%`, width: isSignal ? 5 : 3, height: isSignal ? 5 : 3,
            background: isSignal ? '#1FD18A' : 'rgba(255,255,255,0.55)',
            boxShadow: isSignal ? '0 0 16px #00A86B, 0 0 4px #1FD18A' : 'none',
            animationDelay: `${delay}s`,
          }} />
        );
      })}
    </div>
  );
}

export { tt, Section, Eyebrow, HeroOrbField };
